import { defineMessages } from 'react-intl';
const i18nKey = 'CountryBanner';
const messages = defineMessages({
  bannerDescription: {
    id: `${i18nKey}.bannerDescription`,
    defaultMessage: 'You’re viewing our website for {countryFromUrl}, but it looks like you’re in {countryFromIp}.',
    description: `#Component:Title
      #CharLimit:120
      #Context: Country banner text
      #VariableExample: You’re viewing our website for United States, but it looks like you’re in Singapore.`
  },
  switchSiteMobileText: {
    id: `${i18nKey}.switchSiteMobileText`,
    defaultMessage: 'Switch site',
    description: `#Component:Button
      #CharLimit:120
      #Context: Switch Site mobile text`
  },
  switchSiteDesktopText: {
    id: `${i18nKey}.switchSiteDesktopText`,
    defaultMessage: 'Switch to {countryFromIp} site',
    description: `#Component:Button
      #CharLimit:120
      #Context: Switch Site desktop text
      #VariableExample: Switch to Singapore site`
  },
  dismissText: {
    id: `${i18nKey}.dismissText`,
    defaultMessage: 'Dismiss',
    description: `#Component:Button
      #CharLimit:120
      #Context: Dismiss`
  },
  countryNameTitleUS: {
    id: `${i18nKey}.countryNameTitleUS`,
    defaultMessage: 'United States',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: United States`
  },
  countryNameTitleDE: {
    id: `${i18nKey}.countryNameTitleDE`,
    defaultMessage: 'Germany',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: Germany`
  },
  countryNameTitleUK: {
    id: `${i18nKey}.countryNameTitleUK`,
    defaultMessage: 'United Kingdom',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: United Kingdom`
  },
  countryNameTitleFR: {
    id: `${i18nKey}.countryNameTitleFR`,
    defaultMessage: 'France',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: France`
  },
  countryNameTitleCA: {
    id: `${i18nKey}.countryNameTitleCA`,
    defaultMessage: 'Canada',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: Canada`
  },
  countryNameTitleBR: {
    id: `${i18nKey}.countryNameTitleBR`,
    defaultMessage: 'Brazil',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: Brazil`
  },
  countryNameTitleES: {
    id: `${i18nKey}.countryNameTitleES`,
    defaultMessage: 'Spain',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: Spain`
  },
  countryNameTitlePT: {
    id: `${i18nKey}.countryNameTitlePT`,
    defaultMessage: 'Portugal',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: Portugal`
  },
  countryNameTitleSG: {
    id: `${i18nKey}.countryNameTitleSG`,
    defaultMessage: 'Singapore',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: Singapore`
  },
  countryNameTitleAU: {
    id: `${i18nKey}.countryNameTitleAU`,
    defaultMessage: 'Australia',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page
    #VariableExample: Australia`
  },
  countryNameTitleIT: {
    id: `${i18nKey}.countryNameTitleIT`,
    defaultMessage: 'Italy',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page`
  },
  countryNameTitleNL: {
    id: `${i18nKey}.countryNameTitleNL`,
    defaultMessage: 'Netherlands',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page`
  },
  countryNameTitleAR: {
    id: `${i18nKey}.countryNameTitleAR`,
    defaultMessage: 'Argentina',
    description: `#Component:Title
    #CharLimit:120
    #Context: Country name title text for Country Banner page`
  }
});
let SupportedCountryCode = /*#__PURE__*/function (SupportedCountryCode) {
  SupportedCountryCode["AU"] = "AU";
  SupportedCountryCode["US"] = "US";
  SupportedCountryCode["CA"] = "CA";
  SupportedCountryCode["UK"] = "GB";
  SupportedCountryCode["DE"] = "DE";
  SupportedCountryCode["NZ"] = "NZ";
  SupportedCountryCode["IN"] = "IN";
  SupportedCountryCode["ES"] = "ES";
  SupportedCountryCode["SG"] = "SG";
  SupportedCountryCode["NL"] = "NL";
  SupportedCountryCode["FR"] = "FR";
  SupportedCountryCode["IT"] = "IT";
  SupportedCountryCode["BR"] = "BR";
  SupportedCountryCode["PT"] = "PT";
  SupportedCountryCode["AR"] = "AR";
  return SupportedCountryCode;
}({});
const countryMap = {
  [SupportedCountryCode.US]: messages.countryNameTitleUS,
  [SupportedCountryCode.DE]: messages.countryNameTitleDE,
  [SupportedCountryCode.UK]: messages.countryNameTitleUK,
  [SupportedCountryCode.FR]: messages.countryNameTitleFR,
  [SupportedCountryCode.CA]: messages.countryNameTitleCA,
  [SupportedCountryCode.BR]: messages.countryNameTitleBR,
  [SupportedCountryCode.ES]: messages.countryNameTitleES,
  [SupportedCountryCode.PT]: messages.countryNameTitlePT,
  [SupportedCountryCode.SG]: messages.countryNameTitleSG,
  [SupportedCountryCode.AU]: messages.countryNameTitleAU,
  [SupportedCountryCode.IT]: messages.countryNameTitleIT,
  [SupportedCountryCode.NL]: messages.countryNameTitleNL,
  [SupportedCountryCode.AR]: messages.countryNameTitleAR
};
export { SupportedCountryCode, countryMap, i18nKey, messages };
//# sourceMappingURL=messages.js.map
